import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { Button } from '../../ui/button'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select'
import { requestCreator } from '../../../utilities/requests'

const { post: joinWaitlist } = requestCreator()

function messageFromWaitlistError(error) {
  const data = error.response?.data
  if (!data) return 'Something went wrong. Please try again.'
  if (Array.isArray(data.errors)) return data.errors.join(' ')
  if (typeof data.errors === 'string') return data.errors
  if (data.error && typeof data.error === 'string') return data.error
  return 'Something went wrong. Please try again.'
}

function WaitlistButton({ classOptions, studentId, facilityId, onSuccess, onError }) {
  const [isLoading, setIsLoading] = useState(false)
  const [onWaitlist, setOnWaitlist] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [selectedKlassId, setSelectedKlassId] = useState(classOptions[0]?.id?.toString() || '')

  useEffect(() => {
    setSelectedKlassId(classOptions[0]?.id?.toString() || '')
  }, [classOptions])

  async function handleJoinWaitlist() {
    if (!selectedKlassId) return
    setIsLoading(true)
    setErrorMessage(null)
    try {
      await joinWaitlist(`/api/facilities/${facilityId}/klasses/${selectedKlassId}/waitlist_entries`, {
        student_id: studentId
      })
      setOnWaitlist(true)
      if (onSuccess) onSuccess()
    } catch (error) {
      if (!axios.isCancel(error)) {
        const message = messageFromWaitlistError(error)
        setErrorMessage(message)
        if (onError) onError(error)
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="flex flex-col gap-1 items-start">
      {classOptions.length > 1 ? (
        <Select value={selectedKlassId} onValueChange={setSelectedKlassId}>
          <SelectTrigger className="h-8 w-full min-w-48">
            <SelectValue placeholder="Select class" />
          </SelectTrigger>
          <SelectContent>
            {classOptions.map((klassOption) => (
              <SelectItem key={klassOption.id} value={klassOption.id.toString()}>
                {klassOption.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : null}
      <Button
        onClick={handleJoinWaitlist}
        disabled={isLoading || onWaitlist || !selectedKlassId}
        variant="outline"
        size="sm"
      >
        {onWaitlist ? 'On Waitlist' : 'Join Waitlist'}
      </Button>
      {errorMessage ? (
        <p className="text-sm text-red-600 text-balance" role="alert">
          {errorMessage}
        </p>
      ) : null}
    </div>
  )
}

WaitlistButton.propTypes = {
  classOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  studentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  facilityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

export default WaitlistButton
